import React, { useCallback, useEffect, useState } from 'react';
import { StateType } from 'reducer';
import { usePersistRFVReducer } from 'reducer/reasonForVisit';
import { PodiatryConditionalOptionsType } from 'types/types';
import styles from 'components/podiatry/page.module.scss';
import MetaTag from 'components/meta';
import Button from 'components/common/button';
import clsx from 'clsx';

type Props = {
  nextPage: number;
  currentPage?: number;
  actionPage: string;
  options: PodiatryConditionalOptionsType;
  multiple?: boolean;
  nextOrSubmitButton: (nextPage: number, submit?: boolean) => void;
};

function HaveYouSeenOtherProviders({
  nextPage,
  nextOrSubmitButton,
  options,
  multiple = true,
  actionPage,
}: Props) {
  const [title, setTitle] = useState('');
  const [questionOptions, setQuestionOPtions] = useState<string[]>([]);
  const [error, setError] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string[]>([]);
  const [state, dispatch] = usePersistRFVReducer();

  useEffect(() => {
    setQuestionOPtions(options.options);
    setTitle(options.title);
    if (state) {
      const data = state.find((object: StateType) => object.name === actionPage);
      if (data) setSelectedOption(data.value);
    }
  }, []);

  const onSelectOptions = useCallback((item: string) => {
    if (multiple) {
      setSelectedOption((old) => {
        if (old.find((value) => value === item)) {
          return old.filter((data) => data !== item);
        } return [...old, item];
      });
    } else {
      setSelectedOption([item]);
    }
    setError(false);
  }, [multiple]);

  const clickNextOrSubmit = async (nextPage: number) => {
    if (selectedOption.length === 0) {
      setError(true);
      return;
    }
    await dispatch({
      type: actionPage,
      name: title,
      value: selectedOption,
    });

    const isSubmit = selectedOption.toString() === 'No';

    nextOrSubmitButton(nextPage, isSubmit);
  };

  return (
    <>
      <MetaTag title={title} />
      <h2 className={`marginTopZero ${styles.titleText}`}>{title}</h2>
      {error && (
        <p className="error-message">Please select an option.</p>
      )}
      <div>
        {questionOptions.map((option) => {
          const selectedClass = selectedOption.find(
            (item) => item === option,
          );
          return (
            <p
              key={option}
              className={clsx('option', { 'selected-option': selectedClass })}
              onClick={() => onSelectOptions(option)}
              onKeyUp={() => {}}
            >
              {option}
            </p>
          );
        })}
      </div>
      <div className="next-button-fixed">
        <Button onClick={() => clickNextOrSubmit(nextPage)}>
          {selectedOption[0] === 'Yes' ? 'Next' : 'Submit'}
        </Button>
      </div>
    </>
  );
}

export default HaveYouSeenOtherProviders;
